<!--
 * @Author: zhaohaozhuang
 * @Date: 2023-06-26 17:34:21
 * @LastEditors: zhaohaozhuang
 * @LastEditTime: 2023-07-07 10:10:57
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
<div>
  <div class="xf-aifamliy" v-if="strm === 'share'" @click="changeRouter">
    <img src="https://image.xiaomaiketang.com/xm/internal/x7J7C8cZa3.png" alt="" />
  </div>
  <PosterAiFamily :visible="show" @onClose="hanldeTogglePoster" />
</div>
</template>

<script>
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import PosterAiFamily from './PosterAiFamily.vue'
export default {
  components: {
    PosterAiFamily
  },
  data() {
    return {
      url: '',
      aiAppId: {
        dev: 'wx974897983a27a205',
        gray: 'wxf2de0c99bbc23fb0',
        rc: 'wx974897983a27a205',
        prod: 'wxf2de0c99bbc23fb0',
      }, //AI家教appId
      strm: '',
      show:false
    };
  },
  mounted() {
    this.getUrlParams('type');
    // this.getRouteUrl();
  },
  methods: {
    getUrlParams(type) {
      console.log(type, 'type..........');
      let str = getUrlParam(type);
      console.log(str, 'str+++++++++++++++++++');
      this.strm = str;
    },
    hanldeTogglePoster(){
      this.show=false;
    },
    changeRouter() {
      this.show=true;
      console.log('执行跳转操作');
    },
    // getRouteUrl() {
    //   console.log(process.env.VUE_APP_DEPLOY_ENV, 'process.env.VUE_APP_DEPLOY_ENV');
    //   const params = {
    //     appId: this.aiAppId[process.env.VUE_APP_DEPLOY_ENV],
    //     path: 'pages/aifamily/list/list',
    //   };
    //   fetch.pureUrl('customer/anon/wechat/generatescheme', params).then((res) => {
    //     this.url = res.result;
    //   });
    //   console.log('loadSuccess');
    // },
  },
};
</script>
<style lang="less" scoped>
.xf-aifamliy {
  position: fixed;
  right: 0;
  bottom: 150px;
  img {
    width: 65px;
    height: 70px;
    z-index: 99;
  }
}
</style>
